import { LiberacaoPresencialStruct } from '../../structs/vendas/liberacao-presencial.struct';

// Troca de etapa de um documento.
//
// Note o que NÃO está aqui: a lista de vendedores permitidos. Ela é resolvida no
// OrquestradorVendas a partir do usuário logado — se viesse daqui, bastaria editar a chamada
// para mover o card de qualquer vendedor.
export class MoverVendaEtapaRequest {
    public idVenda: number;

    public idEtapaKanbanDestino: number;

    // Obrigatório quando a etapa de DESTINO exige motivo (isMotivoObrigatorio).
    public idMotivoTransicao: number | null = null;

    // Texto livre do painel de motivo, gravado como justificativa da ocorrência; opcional mesmo
    // quando o motivo é obrigatório.
    public justificativa: string | null = null;

    // "Liberar agora" para converter um orçamento vencido (§12.7): a credencial do supervisor e o motivo,
    // conferidos no orquestrador como no salvar. Nulo no movimento comum.
    public liberacaoPresencial: LiberacaoPresencialStruct | null = null;

    // T17: o usuário já viu o alerta de voltar etapa ou cancelar com integrações; o servidor move sem perguntar de novo.
    public isMovimentoConfirmado: boolean = false;

    // T17: o que o usuário marcou para desfazer antes de mover (VendaTipoIntegracaoEnum: 1 financeiro, 2 estoque).
    public idsVendaTipoIntegracaoDesfazer: number[] = [];
}
